import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getFuelSupplyList as getFuelSupplyListApi,
	getFuelSupplyListQuery as getFuelSupplyListQueryApi,
	getFuelSupply as getFuelSupplyApi,
	addNewFuelSupply as addNewFuelSupplyApi,
	updateFuelSupply as updateFuelSupplyApi,
	deleteFuelSupply as deleteFuelSupplyApi,
	getFuelSupplySummary as getFuelSupplySummaryApi,
	getFuelSupplySummaryQuery as getFuelSupplySummaryQueryApi,
	getFuelSupplySummaryByEstablishment as getFuelSupplySummaryByEstablishmentApi,
	getFuelSupplySummaryByMonth as getFuelSupplySummaryByMonthApi,
	getConsumptionByEstablishment as getConsumptionByEstablishmentApi,
	getConsumptionTypeSummary as getConsumptionTypeSummaryApi,
	getHourMeterSummary as getHourMeterSummaryApi,
	getEmissionsSummary as getEmissionsSummaryApi,
	getConsumptionsSummary as getConsumptionsSummaryApi,
	getSupplyByCenterQuery as getSupplyByCenterQueryApi,
} from '../../helpers/establishment/backend_helper';

export const getFuelSupplyList = createAsyncThunk(
	'fuelSupply/getFuelSupplyList',
	async params => {
		try {
			const response = getFuelSupplyListApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getFuelSupplyListQuery = createAsyncThunk(
	'fuelSupply/getFuelSupplyListQuery',
	async params => {
		try {
			const response = getFuelSupplyListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getFuelSupplyListFilter = createAsyncThunk(
	'fuelSupply/getFuelSupplyListFilter',
	async params => {
		try {
			const response = getFuelSupplyListApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getFuelSupply = createAsyncThunk(
	'fuelSupply/getFuelSupply',
	async fuelSupply_id => {
		try {
			const response = getFuelSupplyApi(fuelSupply_id);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getFuelSupplySummary = createAsyncThunk(
	'fuelSupply/getFuelSupplySummary',
	async params => {
		try {
			const response = getFuelSupplySummaryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getFuelSupplySummaryQuery = createAsyncThunk(
	'fuelSupply/getFuelSupplySummaryQuery',
	async params => {
		try {
			const response = getFuelSupplySummaryQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getFuelSupplySummaryByEstablishment = createAsyncThunk(
	'fuelSupply/getFuelSupplySummaryByEstablishment',
	async ({ establishment_id, code }) => {
		try {
			const response = getFuelSupplySummaryByEstablishmentApi(
				establishment_id,
				code
			);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getFuelSupplySummaryByMonth = createAsyncThunk(
	'fuelSupply/getFuelSupplySummaryByMonth',
	async () => {
		try {
			const response = getFuelSupplySummaryByMonthApi();
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const addNewFuelSupply = createAsyncThunk(
	'fuelSupply/addNewFuelSupply',
	async fuelSupply => {
		try {
			const response = addNewFuelSupplyApi(fuelSupply);
			toast.success('Movimiento de Combustible agregado exitosamente.', {
				autoClose: 3000,
			});
			return response;
		} catch (error) {
			toast.error('Error al agregar fuelSupply.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const updateFuelSupply = createAsyncThunk(
	'fuelSupply/updateFuelSupply',
	async fuelSupply => {
		try {
			const response = updateFuelSupplyApi(fuelSupply);
			toast.success('Movimiento de Combustible actualizado exitosamente', {
				autoClose: 3000,
			});
			return response;
		} catch (error) {
			toast.error('Error al actualizar fuelSupply.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteFuelSupply = createAsyncThunk(
	'fuelSupply/deleteFuelSupply',
	async fuelSupply => {
		try {
			const response = await deleteFuelSupplyApi(fuelSupply);
			toast.success('Movimiento de Combustible eliminado exitosamente.', {
				autoClose: 3000,
			});
			return { fuelSupply, ...response };
		} catch (error) {
			toast.error('Error al eliminar fuelSupply.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const getConsumptionByEstablishment = createAsyncThunk(
	'fuelTank/getConsumptionByEstablishment',
	async ({ establishment_id, filter, type }) => {
		try {
			const response = await getConsumptionByEstablishmentApi({
				establishment_id,
				filter,
				type,
			});
			return { establishment_id, type, data: response }; // Aquí agregamos `type` en el payload
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getConsumptionTypeSummary = createAsyncThunk(
	'fuelTank/getConsumptionSummary',
	async params => {
		try {
			const response = getConsumptionTypeSummaryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getHourMeterSummary = createAsyncThunk(
	'fuelTank/getHourMeterSummary',
	async ({ establishment_id, filter, type, group, company_id }) => {
		try {
			const response = await getHourMeterSummaryApi({
				establishment_id,
				filter,
				type,
				group,
				company_id,
			});
			return { establishment_id, type, data: response }; // Aquí agregamos `type` en el payload
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getEmissionsSummary = createAsyncThunk(
	'fuelTank/getEmissionsSummary',
	async ({ establishment_id, filter, group, company_id }) => {
		try {
			const response = await getEmissionsSummaryApi({
				establishment_id,
				filter,
				group,
				company_id,
			});
			return { establishment_id, data: response };
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getConsumptionsSummary = createAsyncThunk(
	'fuelTank/getConsumptionsSummary',
	async ({ establishment_id, filter, group, company_id }) => {
		try {
			const response = await getConsumptionsSummaryApi({
				establishment_id,
				filter,
				group,
				company_id,
			});
			return { establishment_id, data: response };
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getSupplyByCenterQuery = createAsyncThunk(
	'fuelSupply/getSupplyByCenterQuery',
	async params => {
		try {
			const response = getSupplyByCenterQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);
